

// import React, { useState, useMemo } from "react";
// import {
//   Users,
//   Database,
//   AppWindow,
//   Server,
//   Radar,
//   ShieldCheck,
//   X,
//   ArrowUpRight,
//   ArrowDownRight,
//   Minus,
//   Target,
//   Gauge,
// } from "lucide-react";
// import "./App.css";

// /* ---------------------------------- Theme Palette ---------------------------------- */
// const C = {
//   bg: "#0A0F1C",
//   surface: "#111A2C",
//   surfaceAlt: "#16213A",
//   border: "#25314C",
//   borderLight: "#31405F",
//   text: "#E8ECF6",
//   textDim: "#8B96B4",
//   textFaint: "#59648A",
//   gold: "#D4A73D",
//   goldSoft: "rgba(212,167,61,0.12)",
//   critical: "#E2434A",
//   high: "#E8912D",
//   medium: "#E8C547",
//   low: "#3FB88B",
//   people: "#6FA8DC",
//   process: "#B48EAD",
//   tech: "#3FB88B",
// };

// const band = (v) => {
//   if (v >= 4) return C.low;
//   if (v >= 3) return C.gold;
//   if (v >= 2) return C.high;
//   return C.critical;
// };

// const gapBand = (g) => {
//   if (g >= 2) return C.critical;
//   if (g >= 1.5) return C.high;
//   if (g >= 1) return C.medium;
//   return C.low;
// };

// const TIER = ["Initial", "Basic", "Capable", "Efficient", "Optimizing"];
// const tierLabel = (v) => {
//   const idx = Math.max(0, Math.min(4, Math.round(v) - 1));
//   return TIER[idx];
// };

// /* ---------------------------------- Data ---------------------------------- */
// const DOMAINS = [
//   {
//     id: "grc",
//     name: "GRC",
//     icon: ShieldCheck,
//     desc: "Governance, risk & compliance",
//     current: 2.28,
//     target: 3.92,
//     gap: 1.64,
//     industry: 2.47,
//     ppt: { people: 0.323, process: 0.325, tech: 0.352 },
//     controls: [
//       { name: "Governance Structure", current: 3.00, target: 4.17, gap: 1.17, industry: 2.28, ppt: { people: 0.35, process: 0.408, tech: 0.242 }, votes: [0, 0, 6, 0, 0] },
//       { name: "Information Security Policy", current: 2.83, target: 4.17, gap: 1.34, industry: 2.46, ppt: { people: 0.275, process: 0.325, tech: 0.4 }, votes: [0, 1, 5, 0, 0] },
//       { name: "Enterprise Security Architecture", current: 2.00, target: 3.67, gap: 1.67, industry: 1.74, ppt: { people: 0.288, process: 0.288, tech: 0.423 }, votes: [0, 6, 0, 0, 0] },
//       { name: "Security Risk Management", current: 2.00, target: 3.67, gap: 1.67, industry: 2.77, ppt: { people: 0.305, process: 0.405, tech: 0.29 }, votes: [0, 6, 0, 0, 0] },
//       { name: "Regulatory Compliance", current: 3.00, target: 4.17, gap: 1.17, industry: 3.68, ppt: { people: 0.308, process: 0.392, tech: 0.3 }, votes: [0, 1, 4, 1, 0] },
//       { name: "Information Asset Profile", current: 1.83, target: 3.67, gap: 1.84, industry: 1.97, ppt: { people: 0.338, process: 0.405, tech: 0.257 }, votes: [1, 5, 0, 0, 0] },
//       { name: "Threat Risk Assessment", current: 2.00, target: 4.00, gap: 2.00, industry: 1.87, ppt: { people: 0.29, process: 0.25, tech: 0.46 }, votes: [0, 6, 0, 0, 0] },
//       { name: "Security Culture & Awareness Training", current: 2.83, target: 4.17, gap: 1.34, industry: 2.71, ppt: { people: 0.4, process: 0.28, tech: 0.32 }, votes: [0, 1, 5, 0, 0] },
//       { name: "Incident Response & Management", current: 2.33, target: 4.17, gap: 1.84, industry: 2.61, ppt: { people: 0.255, process: 0.238, tech: 0.507 }, votes: [0, 4, 2, 0, 0] },
//       { name: "Security in Business Continuity Planning", current: 1.00, target: 3.33, gap: 2.33, industry: 2.30, ppt: { people: 0.42, process: 0.26, tech: 0.32 }, votes: [6, 0, 0, 0, 0] },
//     ],
//   },
//   {
//     id: "people",
//     name: "People",
//     icon: Users,
//     desc: "Workforce identity & access",
//     current: 2.18,
//     target: 3.86,
//     gap: 1.68,
//     industry: 2.44,
//     ppt: { people: 0.279, process: 0.307, tech: 0.414 },
//     controls: [
//       { name: "Identity Establishment", current: 2.00, target: 4.00, gap: 2.00, industry: 2.89, ppt: { people: 0.25, process: 0.325, tech: 0.425 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Persons Identity Lifecycle Management", current: 2.00, target: 4.00, gap: 2.00, industry: 2.75, ppt: { people: 0.2, process: 0.35, tech: 0.45 }, votes: [0, 4, 0, 0, 0] },
//       { name: "System & Service Account Lifecycle Mgmt", current: 2.75, target: 3.75, gap: 1.00, industry: 2.28, ppt: { people: 0.25, process: 0.25, tech: 0.5 }, votes: [0, 1, 3, 0, 0] },
//       { name: "Authentication Services & SSO", current: 2.25, target: 4.00, gap: 1.75, industry: 2.20, ppt: { people: 0.25, process: 0.325, tech: 0.425 }, votes: [0, 3, 1, 0, 0] },
//       { name: "Authorization Services", current: 2.00, target: 3.75, gap: 1.75, industry: 2.10, ppt: { people: 0.325, process: 0.325, tech: 0.35 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Remote Access To Corporate Data and Apps", current: 2.00, target: 3.50, gap: 1.50, industry: 2.19, ppt: { people: 0.35, process: 0.325, tech: 0.325 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Privileged & Shared Identity Management", current: 2.25, target: 4.00, gap: 1.75, industry: 2.17, ppt: { people: 0.325, process: 0.25, tech: 0.425 }, votes: [0, 3, 1, 0, 0] },
//     ],
//   },
//   {
//     id: "data",
//     name: "Data",
//     icon: Database,
//     desc: "Classification, protection & handling",
//     current: 2.00,
//     target: 3.58,
//     gap: 1.58,
//     industry: 2.34,
//     ppt: { people: 0.438, process: 0.236, tech: 0.326 },
//     controls: [
//       { name: "Information Lifecycle", current: 1.00, target: 3.50, gap: 2.50, industry: 2.76, ppt: { people: 0.9, process: 0.05, tech: 0.05 }, votes: [4, 0, 0, 0, 0] },
//       { name: "Information Governance", current: 2.00, target: 3.75, gap: 1.75, industry: 2.57, ppt: { people: 0.4, process: 0.275, tech: 0.325 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Data at Rest", current: 2.00, target: 3.75, gap: 1.75, industry: 2.83, ppt: { people: 0.375, process: 0.275, tech: 0.35 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Data Flows", current: 2.50, target: 3.50, gap: 1.00, industry: 2.49, ppt: { people: 0.2, process: 0.3, tech: 0.5 }, votes: [0, 2, 2, 0, 0] },
//       { name: "Data Assurance", current: 2.00, target: 3.50, gap: 1.50, industry: 2.50, ppt: { people: 0.4, process: 0.267, tech: 0.333 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Data Environment Configuration", current: 2.50, target: 3.50, gap: 1.00, industry: 1.48, ppt: { people: 0.35, process: 0.25, tech: 0.4 }, votes: [0, 2, 2, 0, 0] },
//     ],
//   },
//   {
//     id: "application",
//     name: "Application",
//     icon: AppWindow,
//     desc: "SDLC, code & release risk",
//     current: 2.47,
//     target: 3.93,
//     gap: 1.47,
//     industry: 1.92,
//     ppt: { people: 0.352, process: 0.291, tech: 0.357 },
//     controls: [
//       { name: "Application Inventory", current: 1.67, target: 4.00, gap: 2.33, industry: 1.94, ppt: { people: 0.4, process: 0.217, tech: 0.383 }, votes: [2, 4, 0, 0, 0] },
//       { name: "Secure Design & Threat Modelling", current: 1.17, target: 3.33, gap: 2.16, industry: 2.04, ppt: { people: 0.46, process: 0.24, tech: 0.3 }, votes: [5, 1, 0, 0, 0] },
//       { name: "Secure Coding Practices", current: 3.33, target: 4.17, gap: 0.84, industry: 1.79, ppt: { people: 0.32, process: 0.32, tech: 0.36 }, votes: [0, 0, 4, 2, 0] },
//       { name: "Application Security Assessment & Testing", current: 3.17, target: 4.17, gap: 1.00, industry: 1.97, ppt: { people: 0.28, process: 0.36, tech: 0.36 }, votes: [0, 0, 5, 1, 0] },
//       { name: "Vulnerability Remediation & Risk Mitigation", current: 3.00, target: 4.00, gap: 1.00, industry: 2.40, ppt: { people: 0.3, process: 0.32, tech: 0.38 }, votes: [0, 0, 6, 0, 0] },
//     ],
//   },
//   {
//     id: "infrastructure",
//     name: "Infrastructure",
//     icon: Server,
//     desc: "On-prem & cloud estate",
//     current: 2.75,
//     target: 4.04,
//     gap: 1.29,
//     industry: 2.50,
//     ppt: { people: 0.246, process: 0.311, tech: 0.443 },
//     controls: [
//       { name: "Asset Management", current: 1.75, target: 3.25, gap: 1.50, industry: 2.43, ppt: { people: 0.3, process: 0.35, tech: 0.35 }, votes: [1, 3, 0, 0, 0] },
//       { name: "Standard Operating Environment", current: 2.00, target: 3.75, gap: 1.75, industry: 2.17, ppt: { people: 0.3, process: 0.4, tech: 0.3 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Patch Management", current: 2.25, target: 3.75, gap: 1.50, industry: 2.37, ppt: { people: 0.125, process: 0.3, tech: 0.575 }, votes: [0, 3, 1, 0, 0] },
//       { name: "Network Security Infrastructure", current: 3.50, target: 4.50, gap: 1.00, industry: 2.37, ppt: { people: 0.225, process: 0.275, tech: 0.5 }, votes: [0, 0, 2, 2, 0] },
//       { name: "Intrusion Defence and Protection", current: 3.00, target: 4.25, gap: 1.25, industry: 2.19, ppt: { people: 0.225, process: 0.275, tech: 0.5 }, votes: [0, 0, 4, 0, 0] },
//       { name: "Vulnerability Scanning & Assessment", current: 3.00, target: 4.00, gap: 1.00, industry: 2.09, ppt: { people: 0.25, process: 0.3, tech: 0.45 }, votes: [0, 0, 4, 0, 0] },
//       { name: "Event Correlation", current: 3.75, target: 4.75, gap: 1.00, industry: 2.41, ppt: { people: 0.3, process: 0.275, tech: 0.425 }, votes: [0, 0, 1, 3, 0] },
//     ],
//   },
//   {
//     id: "advanced",
//     name: "Advanced Industry Controls",
//     icon: Radar,
//     desc: "Sector-specific & emerging threats",
//     current: 2.75,
//     target: 4.04,
//     gap: 1.29,
//     industry: 2.20,
//     ppt: { people: 0.238, process: 0.288, tech: 0.375 },
//     controls: [
//       { name: "Financial Web Fraud Detection and Prevention", current: 2.00, target: 3.75, gap: 1.75, industry: 1.98, ppt: { people: 0.225, process: 0.35, tech: 0.225 }, votes: [0, 4, 0, 0, 0] },
//       { name: "Advanced Malware Protection", current: 3.50, target: 4.33, gap: 0.83, industry: 2.50, ppt: { people: 0.25, process: 0.225, tech: 0.525 }, votes: [0, 0, 3, 0, 1] },
//     ],
//   },
// ];

// const OVERALL = { current: 2.23, target: 3.89, gap: 1.66, industry: 2.31 };

// /* ---------------------------------- Helpers ---------------------------------- */
// function MaturityBar({ current, target, industry, height = 10 }) {
//   const pct = (v) => `${(v / 5) * 100}%`;
//   const c = band(current);
//   return (
//     <div style={{ position: "relative", height, borderRadius: 4, background: C.border, overflow: "visible" }}>
//       <div style={{ width: pct(current), height: "100%", background: c, borderRadius: 4, transition: "width .3s" }} />
//       {industry != null && (
//         <div title={`Industry avg ${industry.toFixed(2)}`} style={{ position: "absolute", left: pct(industry), top: -2, bottom: -2, width: 2, background: C.textFaint }} />
//       )}
//       <div title={`Target ${target.toFixed(2)}`} style={{ position: "absolute", left: pct(target), top: -3, bottom: -3, width: 2, background: C.text }} />
//     </div>
//   );
// }

// function DeltaVsIndustry({ current, industry }) {
//   const d = current - industry;
//   const Icon = d > 0.05 ? ArrowUpRight : d < -0.05 ? ArrowDownRight : Minus;
//   const color = d > 0.05 ? C.low : d < -0.05 ? C.critical : C.textFaint;
//   return (
//     <span className="delta-badge" style={{ color }}>
//       <Icon size={12} /> {d >= 0 ? "+" : ""}{d.toFixed(2)} vs industry
//     </span>
//   );
// }

// function PPTBar({ ppt, height = 6 }) {
//   return (
//     <div style={{ display: "flex", height, borderRadius: 3, overflow: "hidden", background: C.border }}>
//       <div style={{ width: `${ppt.people * 100}%`, background: C.people }} title={`People ${(ppt.people * 100).toFixed(0)}%`} />
//       <div style={{ width: `${ppt.process * 100}%`, background: C.process }} title={`Process ${(ppt.process * 100).toFixed(0)}%`} />
//       <div style={{ width: `${ppt.tech * 100}%`, background: C.tech }} title={`Technology ${(ppt.tech * 100).toFixed(0)}%`} />
//     </div>
//   );
// }

// function PPTLegend({ ppt }) {
//   const seg = [
//     ["People", C.people, ppt.people],
//     ["Process", C.process, ppt.process],
//     ["Technology", C.tech, ppt.tech],
//   ];
//   return (
//     <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//       {seg.map(([label, c, v]) => (
//         <div key={label} style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: C.textDim }}>
//           <span style={{ width: 7, height: 7, borderRadius: 2, background: c, display: "inline-block" }} />
//           {label} <span style={{ color: C.text, fontFamily: "monospace" }}>{(v * 100).toFixed(0)}%</span>
//         </div>
//       ))}
//     </div>
//   );
// }

// function VoteDistribution({ votes }) {
//   const total = votes.reduce((a, b) => a + b, 0) || 1;
//   const max = Math.max(...votes, 1);
//   return (
//     <div style={{ display: "flex", alignItems: "flex-end", gap: "4px", height: "30px" }}>
//       {votes.map((v, i) => (
//         <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "14px" }}>
//           <div
//             title={`Level ${i + 1}: ${v} vote${v === 1 ? "" : "s"}`}
//             style={{
//               width: "100%",
//               height: `${Math.max(v ? (v / max) * 22 : 2, 2)}px`,
//               background: v ? C.gold : C.border,
//               borderRadius: 2,
//               opacity: v ? 0.55 + 0.45 * (v / max) : 1,
//             }}
//           />
//         </div>
//       ))}
//       <span style={{ fontSize: "10px", marginLeft: "4px", color: C.textFaint }}>{total} votes</span>
//     </div>
//   );
// }

// function polar(cx, cy, r, deg) {
//   const rad = ((deg - 90) * Math.PI) / 180;
//   return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
// }

// function arcPath(cx, cy, r, a0, a1) {
//   const s = polar(cx, cy, r, a1);
//   const e = polar(cx, cy, r, a0);
//   const large = a1 - a0 <= 180 ? 0 : 1;
//   return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 0 ${e.x} ${e.y}`;
// }

// function PostureSeal({ current, target }) {
//   const A0 = -130, A1 = 130;
//   const curAngle = A0 + (A1 - A0) * (current / 5);
//   const tgtAngle = A0 + (A1 - A0) * (target / 5);
//   const c = band(current);
//   const ticks = [0, 1, 2, 3, 4, 5];
//   return (
//     <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", width: 216, height: 216 }}>
//       <svg width={216} height={216} viewBox="0 0 216 216">
//         <circle cx={108} cy={108} r={102} fill="none" stroke={C.border} strokeWidth={1} strokeDasharray="1.5 5" />
//         <path d={arcPath(108, 108, 84, A0, A1)} stroke={C.border} strokeWidth={10} fill="none" strokeLinecap="round" />
//         <path d={arcPath(108, 108, 84, A0, curAngle)} stroke={c} strokeWidth={10} fill="none" strokeLinecap="round" />
//         {(() => {
//           const p1 = polar(108, 108, 92, tgtAngle);
//           const p2 = polar(108, 108, 76, tgtAngle);
//           return <line x1={p1.x} y1={p1.y} x2={p2.x} y2={p2.y} stroke={C.text} strokeWidth={2} strokeDasharray="2 2" />;
//         })()}
//         {ticks.map((t) => {
//           const a = A0 + (A1 - A0) * (t / 5);
//           const p1 = polar(108, 108, 76, a);
//           const p2 = polar(108, 108, 68, a);
//           return <line key={t} x1={p1.x} y1={p1.y} x2={p2.x} y2={p2.y} stroke={C.textFaint} strokeWidth={1.5} />;
//         })}
//       </svg>
//       <div style={{ position: "absolute", display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <span style={{ fontSize: "10px", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: "4px", color: C.textFaint }}>Current Posture</span>
//         <span style={{ fontSize: "48px", lineHeight: 1, fontFamily: "monospace", fontWeight: 600, color: C.text }}>
//           {current.toFixed(2)}
//         </span>
//         <span style={{ fontSize: "12px", marginTop: "8px", padding: "2px 8px", borderRadius: "12px", color: c, background: `${c}1A`, border: `1px solid ${c}44` }}>
//           {tierLabel(current)}
//         </span>
//         <span style={{ fontSize: "10px", marginTop: "8px", color: C.textFaint }}>
//           Target <span style={{ color: C.text, fontFamily: "monospace" }}>{target.toFixed(2)}</span>
//         </span>
//       </div>
//     </div>
//   );
// }

// function KpiTile({ label, value, sub, icon: Icon }) {
//   return (
//     <div className="kpi-tile">
//       <div className="kpi-header">
//         <span className="kpi-label">{label}</span>
//         {Icon && <Icon size={13} style={{ color: C.textFaint }} />}
//       </div>
//       <div className="kpi-value">{value}</div>
//       {sub && <div className="kpi-sub">{sub}</div>}
//     </div>
//   );
// }

// function DomainCard({ d, onOpen, active }) {
//   const c = band(d.current);
//   const Icon = d.icon;
//   return (
//     <button className={`domain-card ${active ? "active" : ""}`} onClick={() => onOpen(d.id)}>
//       <div className="domain-header">
//         <div className="domain-icon-box">
//           <div className="icon-bg">
//             <Icon size={16} style={{ color: C.gold }} />
//           </div>
//           <div>
//             <div className="domain-name">{d.name}</div>
//             <div className="domain-desc">{d.desc}</div>
//           </div>
//         </div>
//         <div>
//           <span className="score-main" style={{ color: c }}>{d.current.toFixed(2)}</span>
//           <div className="score-max">/ 5.00</div>
//         </div>
//       </div>

//       <div className="domain-metrics">
//         <MaturityBar current={d.current} target={d.target} industry={d.industry} />
//         <div className="target-gap-row">
//           <span className="target-text">
//             Target <span style={{ color: C.text, fontFamily: "monospace" }}>{d.target.toFixed(2)}</span>
//           </span>
//           <span className="gap-badge" style={{ color: gapBand(d.gap), background: `${gapBand(d.gap)}1A` }}>
//             Gap {d.gap.toFixed(2)}
//           </span>
//         </div>
//       </div>

//       <div style={{ marginBottom: "12px" }}>
//         <PPTBar ppt={d.ppt} />
//       </div>

//       <div className="domain-footer">
//         <span className="tier-label">{tierLabel(d.current)}</span>
//         <DeltaVsIndustry current={d.current} industry={d.industry} />
//       </div>
//     </button>
//   );
// }

// function OverallComparison({ domains }) {
//   return (
//     <div className="comparison-card">
//       <div className="comparison-header">
//         <span className="comparison-title">Current vs Target vs Industry, by domain</span>
//         <div className="legend-group">
//           <span className="legend-item">
//             <span style={{ width: 9, height: 9, borderRadius: 2, background: C.gold, display: "inline-block" }} /> Current
//           </span>
//           <span className="legend-item">
//             <span style={{ width: 2, height: 9, background: C.text, display: "inline-block" }} /> Target
//           </span>
//           <span className="legend-item">
//             <span style={{ width: 2, height: 9, background: C.textFaint, display: "inline-block" }} /> Industry
//           </span>
//         </div>
//       </div>
//       <div className="comparison-list">
//         {domains.map((d) => (
//           <div key={d.id} className="comparison-row">
//             <span className="row-name">{d.name}</span>
//             <MaturityBar current={d.current} target={d.target} industry={d.industry} height={9} />
//             <span className="row-val" style={{ color: band(d.current) }}>{d.current.toFixed(2)}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// function DetailPanel({ d, onClose }) {
//   const Icon = d.icon;
//   const sorted = [...d.controls].sort((a, b) => b.gap - a.gap);
//   return (
//     <div className="detail-panel">
//       <div className="detail-header">
//         <div className="domain-icon-box">
//           <div className="icon-bg">
//             <Icon size={18} style={{ color: C.gold }} />
//           </div>
//           <div>
//             <div className="domain-name" style={{ fontSize: "16px" }}>{d.name}</div>
//             <div className="domain-desc">{d.desc}</div>
//           </div>
//         </div>
//         <button onClick={onClose} className="close-btn">
//           <X size={16} />
//         </button>
//       </div>

//       <div className="detail-stats">
//         <div className="stat-box">
//           <div className="stat-title">Current</div>
//           <span className="stat-num" style={{ color: band(d.current) }}>{d.current.toFixed(2)}</span>
//         </div>
//         <div className="stat-box">
//           <div className="stat-title">Target</div>
//           <span className="stat-num" style={{ color: C.text }}>{d.target.toFixed(2)}</span>
//         </div>
//         <div className="stat-box">
//           <div className="stat-title">Gap</div>
//           <span className="stat-num" style={{ color: gapBand(d.gap) }}>{d.gap.toFixed(2)}</span>
//         </div>
//         <div className="stat-box">
//           <div className="stat-title">Industry avg</div>
//           <span className="stat-num" style={{ color: C.textDim }}>{d.industry.toFixed(2)}</span>
//         </div>
//       </div>

//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
//         <span className="stat-title">Capabilities, ranked by gap</span>
//         <PPTLegend ppt={d.ppt} />
//       </div>
//       <div>
//         {sorted.map((ctl) => (
//           <div key={ctl.name} className="capability-row">
//             <div className="capability-meta">
//               <span className="capability-name">{ctl.name}</span>
//               <div className="capability-scores">
//                 <span style={{ fontSize: "11px", fontFamily: "monospace", color: C.textDim }}>
//                   {ctl.current.toFixed(2)} → {ctl.target.toFixed(2)}
//                 </span>
//                 <span className="gap-badge" style={{ color: gapBand(ctl.gap), background: `${gapBand(ctl.gap)}1A` }}>
//                   gap {ctl.gap.toFixed(2)}
//                 </span>
//               </div>
//             </div>
//             <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "16px", alignItems: "center" }}>
//               <div>
//                 <MaturityBar current={ctl.current} target={ctl.target} industry={ctl.industry} height={7} />
//                 <div style={{ marginTop: "6px" }}><PPTBar ppt={ctl.ppt} height={5} /></div>
//               </div>
//               <VoteDistribution votes={ctl.votes} />
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ---------------------------------- Main App ---------------------------------- */
// export default function App() {
//   const [openId, setOpenId] = useState(null);
//   const openDomain = DOMAINS.find((d) => d.id === openId);

//   const aboveIndustry = useMemo(() => DOMAINS.filter((d) => d.current >= d.industry).length, []);
//   const widestGapDomain = useMemo(() => [...DOMAINS].sort((a, b) => b.gap - a.gap)[0], []);

//   return (
//     <div className="dashboard-container">
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Space+Grotesk:wght@500;600;700&display=swap');`}</style>

//       {/* Header */}
//       <div className="dashboard-header">
//         <div>
//           <div className="header-tag">
//             <ShieldCheck size={16} style={{ color: C.gold }} />
//             Enterprise Security Maturity Workshop
//           </div>
//           <h1 className="header-title">Security Posture & Maturity Gap Assessment</h1>
//         </div>
//         <div className="scale-info">
//           <div className="scale-title">Assessment scale</div>
//           <div className="scale-value">1 Initial – 5 Optimizing</div>
//         </div>
//       </div>

//       <div className="source-badge">
//         Aggregated from workshop participant scoring across 6 domains, 37 capabilities
//       </div>

//       {/* Top Section */}
//       <div className="top-section">
//         <div className="seal-card">
//           <PostureSeal current={OVERALL.current} target={OVERALL.target} />
//         </div>
//         <div className="kpi-grid">
//           <KpiTile label="Overall Current Posture" value={OVERALL.current.toFixed(2)} sub={`of 5.00 · ${tierLabel(OVERALL.current)}`} icon={Gauge} />
//           <KpiTile label="Overall Target Posture" value={OVERALL.target.toFixed(2)} sub={`of 5.00 · ${tierLabel(OVERALL.target)}`} icon={Target} />
//           <KpiTile label="Average Maturity Gap" value={OVERALL.gap.toFixed(2)} sub="levels below target, across domains" />
//           <KpiTile label="Domains At/Above Industry" value={`${aboveIndustry} / ${DOMAINS.length}`} sub={`Widest gap: ${widestGapDomain.name} (${widestGapDomain.gap.toFixed(2)})`} />
//         </div>
//       </div>

//       {/* Overall Comparison */}
//       <OverallComparison domains={DOMAINS} />

//       {/* Domain Breakdown */}
//       <div className="section-header">
//         <h2 className="section-title">DOMAIN BREAKDOWN</h2>
//         <span className="section-hint">Select a domain for capability-level detail</span>
//       </div>
//       <div className="domain-grid">
//         {DOMAINS.map((d) => (
//           <DomainCard key={d.id} d={d} active={d.id === openId} onOpen={(id) => setOpenId(id === openId ? null : id)} />
//         ))}
//       </div>

//       {openDomain && <DetailPanel d={openDomain} onClose={() => setOpenId(null)} />}

//       {/* Footer */}
//       <div className="dashboard-footer">
//         Source: Sample_ESMW_workshop.xlsx — Results Aggregator & Overall Results sheets. Dashed marker = target level; grey tick = industry benchmark.
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import GRCPostureDashboard from "./ESMWPostureDashboard"; // Your existing dashboard component
import GRCResultGraphs from "./GRCResultGraphs"; // New graphs component

export default function App() {
  // Simple router based on window location hash
  const [currentPath, setCurrentPath] = useState(
    window.location.hash === "#/graphs" ? "/graphs" : "/"
  );

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === "#/graphs") {
        setCurrentPath("/graphs");
      } else {
        setCurrentPath("/");
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const navigateTo = (path) => {
    window.location.hash = path === "/graphs" ? "#/graphs" : "#/";
    setCurrentPath(path);
  };

  return (
    <div style={{ backgroundColor: "#0A0F1C", minHeight: "100vh", color: "#E8ECF6" }}>
      {/* Responsive Styles Injection */}
      <style>{`
        .app-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 32px;
          background-color: #111A2C;
          border-bottom: 1px solid #25314C;
          flex-wrap: wrap;
          gap: 12px;
        }

        .nav-buttons {
          display: flex;
          gap: 8px;
          width: auto;
        }

        .nav-btn {
          padding: 8px 18px;
          border-radius: 6px;
          border: 1px solid;
          font-weight: 600;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        /* Mobile Breakpoint (<640px) */
        @media (max-width: 640px) {
          .app-header {
            flex-direction: column;
            align-items: stretch;
            padding: 12px 16px;
          }

          .nav-buttons {
            width: 100%;
          }

          .nav-btn {
            flex: 1;
            text-align: center;
            padding: 8px 10px;
            font-size: 12px;
          }
        }
      `}</style>

      {/* Navigation Topbar */}
      <header className="app-header">
        <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
          <span style={{ color: "#D4A73D", fontWeight: "bold", fontSize: "18px" }}>🛡️ ESMW Portal</span>
          <span style={{ color: "#59648A", fontSize: "12px" }}>| Enterprise Security Assessment</span>
        </div>

        {/* Route Tabs */}
        <nav className="nav-buttons">
          <button
            onClick={() => navigateTo("/")}
            className="nav-btn"
            style={{
              borderColor: currentPath === "/" ? "#D4A73D" : "#25314C",
              backgroundColor: currentPath === "/" ? "rgba(212,167,61,0.15)" : "#16213A",
              color: currentPath === "/" ? "#D4A73D" : "#8B96B4",
            }}
          >
            📊  Dashboard
          </button>
          <button
            onClick={() => navigateTo("/graphs")}
            className="nav-btn"
            style={{
              borderColor: currentPath === "/graphs" ? "#3FB88B" : "#25314C",
              backgroundColor: currentPath === "/graphs" ? "rgba(63,184,139,0.15)" : "#16213A",
              color: currentPath === "/graphs" ? "#3FB88B" : "#8B96B4",
            }}
          >
            📈 Result Graphs
          </button>
        </nav>
      </header>

      {/* Render Component according to route */}
      <main>
        {currentPath === "/graphs" ? <GRCResultGraphs /> : <GRCPostureDashboard />}
      </main>
    </div>
  );
}